var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#5d3b7e",
    d: "M 71.5,-0.5 C 194.167,-0.5 316.833,-0.5 439.5,-0.5C 478.5,8.5 502.5,32.5 511.5,71.5C 511.5,194.167 511.5,316.833 511.5,439.5C 502.5,478.5 478.5,502.5 439.5,511.5C 316.833,511.5 194.167,511.5 71.5,511.5C 32.5,502.5 8.5,478.5 -0.5,439.5C -0.5,316.833 -0.5,194.167 -0.5,71.5C 8.5,32.5 32.5,8.5 71.5,-0.5 Z M 139.5,111.5 C 192.501,111.333 245.501,111.5 298.5,112C 322.628,113.317 342.795,122.817 359,140.5C 370.068,157.549 374.068,176.216 371,196.5C 366.478,221.186 352.644,238.519 329.5,248.5C 356.66,255.492 374.16,272.492 382,299.5C 393.638,356.069 371.472,391.236 315.5,405C 309.218,406.325 302.885,407.325 296.5,408C 244.168,408.5 191.834,408.667 139.5,408.5C 139.5,309.5 139.5,210.5 139.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#5e3a7e",
    d: "M 190.5,152.5 C 220.502,152.333 250.502,152.5 280.5,153C 307.5,153.166 320.834,166.666 320.5,193.5C 320.012,218.491 307.345,232.658 282.5,236C 251.835,236.5 221.168,236.667 190.5,236.5C 190.5,208.5 190.5,180.5 190.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#5d3a7e",
    d: "M 190.5,272.5 C 222.168,272.333 253.835,272.5 285.5,273C 316.001,273.669 332.334,289.169 334.5,319.5C 333.465,348.033 318.799,363.866 290.5,367C 257.168,367.5 223.835,367.667 190.5,367.5C 190.5,335.833 190.5,304.167 190.5,272.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.6a305f7c00ab1410b74376f443e30086.svg";
export { ForwardRef as ReactComponent };